// machineResponseService.js

import workspace from "./workspace"; // same Axios instance

export const getMachineResponses = async () => {
  try {
    const response = await workspace.get(`/machine-response/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching machine response items:", error);
    throw error;
  }
};

export const getMachineResponseById = async (id) => {
  try {
    const response = await workspace.get(`/machine-response/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching machine response with ID ${id}:`, error);
    throw error;
  }
};

export const createMachineResponse = async (data) => {
  try {
    const response = await workspace.post(`/machine-response/`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating machine response:", error);
    throw error;
  }
};

export const updateMachineResponse = async (id, data) => {
  try {
    const response = await workspace.put(`/machine-response/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating machine response with ID ${id}:`, error);
    throw error;
  }
};

export const deleteMachineResponse = async (id) => {
  try {
    const response = await workspace.delete(`/machine-response/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting machine response with ID ${id}:`, error);
    throw error;
  }
};
